export { MorphemeDetailsTileGlossSection } from "#morpheme-details-tile-gloss-section";
export { morphemeGlossEmphasisClassName } from "#morpheme-gloss-emphasis-class-name";
